// ---------------------------------------------------------------------------
// Which result entity is selected — shared between CalculationResults.tsx
// (panel, with tabs per level) and SubBasinMap.tsx (clicking a sub-basin, an
// outlet point or an aquifer on the map selects the same thing). Zone is the
// only one of the 4 levels without its own geometry — it can't be selected
// from the map, only from the panel (see EditBar.tsx for the same "not
// everything is selectable on the map" pattern already used in editing).
// ---------------------------------------------------------------------------

export type ResultLevel = "subBasin" | "outletPoint" | "zone" | "aquifer";

export interface ResultSelection {
  level: ResultLevel;
  id: number;
}

export function sameSelection(a: ResultSelection | null, b: ResultSelection): boolean {
  return !!a && a.level === b.level && a.id === b.id;
}
